import { SUPPORT_EMAIL } from '~/constants';
import React from 'react';

export interface ErrorPageTemplateProps {
  title: string;
  children?: React.ReactNode | React.ReactNodeArray;
  hideFooter?: boolean;
}

export const ErrorPageTemplate: React.FC<ErrorPageTemplateProps> = (props: ErrorPageTemplateProps) => {
  let { title, children, hideFooter } = props;

  return (
    <section className="w-full flex min-h-screen items-center justify-center">
      <div className="bg-gray-100 rounded p-4 shadow text-gray-700 max-w-xl">
        <h1 className="border-b font-semibold text-lg mb-4 px-4 py-2 text-center uppercase">{title}</h1>

        <div>{children}</div>

        {!hideFooter && (
          <p className="py-2 text-center">
            We automatically log these errors and try to resolve these as quickly as possible, if this error persists
            feel free to reach out at{' '}
            <a href={`mailto:${SUPPORT_EMAIL}`} className="underline text-blue-400">
              {SUPPORT_EMAIL}
            </a>
          </p>
        )}
      </div>
    </section>
  );
};

export interface ErrorFallbackProps {
  title?: string;
  message?: string;
}

export const ErrorFallback: React.FC<ErrorFallbackProps> = (props) => {
  let { title = 'Something went wrong', message } = props;

  return (
    <ErrorPageTemplate title={title}>
      <p className="my-4 text-center">{message}</p>
      <p className="text-center">
        <a href="/" className="block text-white rounded py-2 px-4 w-full bg-blue-600">
          Go to overview
        </a>
      </p>
    </ErrorPageTemplate>
  );
};
